import { onSetLanguageTag } from '@/paraglide/runtime';

type Listener = (languageTag: string) => void;

const listeners = new Set<Listener>();
let registered = false;

/**
 * Subscribe to paraglide language changes; returns an unsubscribe function.
 *
 * paraglide's own `onSetLanguageTag` holds exactly ONE callback and the last registration wins,
 * but a host page can run several shops at once (an inline `<shop-embed>` next to a
 * `<shop-widget>` pill). Registering each ShopProvider directly meant only the last-mounted shop
 * refetched its server-translated content on a language switch — the others changed their UI
 * strings but kept product names and descriptions in the old language (FAS-1689).
 */
export function subscribeToLanguageChange(listener: Listener): () => void {
  if (!registered) {
    onSetLanguageTag((tag) => listeners.forEach((l) => l(tag)));
    registered = true;
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
